export const PATHS = {
  menu: '/cardapio',
  cart: '/carrinho',
  products: {
    items: '/produtos/itens',
    categories: '/produtos/categorias'
  },
  orders: '/pedidos',
  login: '/login',
  schedule: '/horarios'
}